import { QUERY_KEYS } from '../../../../consts';
import { verifyPatientBirthDateService } from '../../../../services';
import { getAtomWithMutation } from '../../../../utils';

export const verifyPatientBirthDateAtom = getAtomWithMutation({
  mutationKey: QUERY_KEYS.BST.VERIFY_PATIENT_BIRTH_DATE,
  mutationFn: () => verifyPatientBirthDateService,
  retry: 0, // Important. There's a limit of 3 tries per patient, if we retry it's going to run out faster than expected
});
